module.exports = __webpack_public_path__ + "static/media/icons_Bilan APA.892067e9.svg";